import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useEditorDrag } from "../../../canvas/dnd/useEditorDrag";
import { usePaletteItemActivate } from "../../../canvas/dnd/usePaletteItemActivate";
import { COLUMN_PRESETS } from "../../../domain/column-presets";
import type { DragData } from "../../../domain/dnd/types";
import { insertRowFromPalette } from "./columnPaletteInsert";
import "components/builderShell/builderToolbarMenuView.scss";
import "./emailBuilderAddElementsPanel.scss";

interface IEmailBuilderColumnPaletteProps {
  onAfterInsert?: () => void;
}

export function EmailBuilderColumnPalette(props: IEmailBuilderColumnPaletteProps) {
  const { onAfterInsert } = props;
  const { t } = useTranslation();

  return (
    <div className="builder-toolbar-palette-grid">
      {COLUMN_PRESETS.map(preset => (
        <ColumnPaletteItem
          key={preset.id}
          id={`palette-row:${preset.id}`}
          label={t(preset.label)}
          ratios={preset.ratios}
          dragData={{ kind: "palette-row", presetId: preset.id }}
          onInsert={() => {
            insertRowFromPalette(preset.id);
            onAfterInsert?.();
          }}
        />
      ))}
    </div>
  );
}

function ColumnPaletteItem({
  id,
  label,
  ratios,
  dragData,
  onInsert,
}: {
  id: string;
  label: string;
  ratios: number[];
  dragData: DragData;
  onInsert: () => void;
}) {
  const { dragRef, isDragging } = useEditorDrag(dragData, { id });
  const handleActivate = usePaletteItemActivate(onInsert, isDragging);

  return (
    <button
      type="button"
      ref={dragRef}
      aria-label={label}
      title={label}
      className={classNames("builder-toolbar-palette-item", {
        "builder-toolbar-palette-item--dragging": isDragging,
      })}
      style={{ opacity: isDragging ? 0.45 : 1 }}
      onClick={handleActivate}
    >
      <span className="email-builder-column-palette-preview" aria-hidden="true">
        {ratios.map((ratio, index) => (
          <span
            key={index}
            className="email-builder-column-palette-preview-col"
            style={{ flexGrow: ratio, flexBasis: 0 }}
          />
        ))}
      </span>
      <span className="builder-toolbar-palette-item-title">{label}</span>
    </button>
  );
}
